var exports = {
  "o": "issueDetailContainer__jh85_b",
};

module.exports = exports;
